export enum MaskEnum {
    PHONE = 1,
    CPF = 2,

}
